/* eslint-disable no-unused-vars */
// **  cognito helper
import { CognitoAuth } from "@contexts/auth/cognito"

import { adminsApiGet, adminsApiPost, adminsApiPut } from "@helpers/adminsApiClient"
import { canonicalAdminRole } from "@configs/adminRoles"
// **  store names
import { STORES } from "@constants/redux"

// ** main app Logger
import { appLogger } from "@helpers/logger"

import { userRoles } from "@constants/system"
// ** constants
import { globalConst } from "@constants/global"

// ** system wide config
import systemConfig from "@configs/systemConfig"

// ** Acl subject,actions
import { AclSubjects, AclActions } from "@constants/acl"

// **  utility
import { isEmpty, drop } from "lodash"

// ** Store import
import { store } from "@redux/store"

/** users groups */
const GROUP = globalConst.auth.groups

// ** fuzzy search support
import Fuse from "fuse.js"

import apiService from "../../services/apiService"
import toast from "react-hot-toast"

const shouldSkipProtectedDashboardCalls = () => {
  // Server-authoritative admin dashboard: disable local fallback mode.
  return false
}

const STAFF_V1 = "/stuffs/v1"
const staffPath = (id = "", suffix = "") =>
  id ? `${STAFF_V1}/${id}${suffix}` : `${STAFF_V1}/`

/** initla state for auth store  */
const initialState = {
  data: [],
  current: {},
  currentPage: 1,
  perPageValues: [5, 10, 25, 50],
  itemPerPage: 5,
  filters: {},
  message: "",
  error: "",
  keyword: null,
  action: globalConst.action.NONE
}

export const stuffs = {
  state: initialState,

  reducers: {
    /**
     * Set translate message
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setMessage: (s, payload) => {
      return {
        ...s,
        message: payload
      }
    },
    /**
     * Set error message
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setError: (s, payload) => {
      return {
        ...s,
        error: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setData: (s, payload) => {
      return {
        ...s,
        data: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    pushNewData: (s, payload) => {
      return {
        ...s,
        data: [...s.data, payload]
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setFilters: (s, payload) => {
      return {
        ...s,
        filters: { ...s.filters, ...payload }
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setKeyword: (s, payload) => {
      return {
        ...s,
        keyword: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setitemPerPage: (s, payload) => {
      return {
        ...s,
        itemPerPage: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrent: (s, payload) => {
      return {
        ...s,
        current: payload
      }
    },

    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setAction: (s, payload) => {
      return {
        ...s,
        action: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrentPage: (s, payload) => {
      return {
        ...s,
        currentPage: payload
      }
    }
  },
  selectors: (slice, createSelector) => ({
    /**
     *
     * @returns
     */
    error() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.stuffs],
        (stuffs, stuffsLoading) => {
          return stuffsLoading.error || ""
        }
      )
    },

    /**
     * success selector used in different
     * auth actions
     *
     * @returns {String}
     */
    success() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.stuffs],
        (stuffs, stuffsLoading) => stuffsLoading.success
      )
    },
    paginationData() {
      return createSelector([slice], (stuffs) => {
        let data = stuffs.data

        // Apply role filter if it exists
        if (stuffs.filters && stuffs.filters.role && stuffs.filters.role !== "all") {
          const role = stuffs.filters.role
          // Check both group and role fields
          data = data.filter((e) => e.group === role || e.role === role)
        }

        // Apply status filter if it exists
        if (stuffs.filters && stuffs.filters.status && stuffs.filters.status !== "all") {
          const status = stuffs.filters.status
          data = data.filter((e) => e.status === status)
        }

        // Apply keyword search if it exists
        if (stuffs.keyword) {
          const options = {
            keys: ["nickname", "name", "email"]
          }
          const fuse = new Fuse(data, options)
          data = fuse.search(stuffs.keyword)
          data = data.map((e) => e.item)
        }

        // Apply pagination
        const offset = (stuffs.currentPage - 1) * stuffs.itemPerPage
        const paginatedData = drop(data, offset).slice(0, stuffs.itemPerPage)
        
        return paginatedData
      })
    }
  }),
  effects: (dispatch) => ({
    /**
     *
     */
    async fetchStuffs() {
      appLogger.info("fetchStuffs", `[REDUX][${STORES.STUFFS}]`)
      this.setAction(globalConst.action.FETCH_STUFFS)
      if (shouldSkipProtectedDashboardCalls()) {
        this.setData([])
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
        const result = await adminsApiGet(staffPath())
        const records = Array.isArray(result) ? result : result?.data || []
        const validResult = records.filter((staff) => {
          const isNotDeleted = staff.status !== "DELETED" && !staff.isDeleted
          const isNotTemporary = !staff.pk || !staff.pk.startsWith("temp_")
          const hasValidId =
            staff.pk && staff.pk !== "new" && staff.pk !== "undefined" && staff.pk !== "null"
          return isNotDeleted && isNotTemporary && hasValidId
        })
        this.setData(validResult || [])
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setData([])
        this.setAction(globalConst.action.NONE)
      }
    },
    /**
     *
     * @param {*} payload
     */
    async saveNewStuff(payload) {
      appLogger.info("saveNewStuff", `[REDUX][${STORES.STUFFS}]`)
      this.setAction(globalConst.action.ADD_NEW_SUFF)
      try {
        const role = canonicalAdminRole(payload.role || payload.group)
        const cognitoResult = await adminsApiPost(staffPath(), {
          email: payload.email,
          password: payload.password,
          name: payload.fullname || payload.name,
          nickname: payload.nickname,
          role,
          group: role
        })
        if (!cognitoResult?.pk && !cognitoResult?.userId && !cognitoResult?.id) {
          throw new Error("Server did not return a valid PK for the new staff member")
        }
        this.setMessage("msg_stuffs_added_sucess")
        this.setAction(globalConst.action.NONE)
        await this.fetchStuffs()
      } catch (error) {
        const errorMessage = error.message || "Failed to add new staff member"
        this.setError(errorMessage)
        this.setAction(globalConst.action.NONE)
        throw new Error(errorMessage)
      }
    },
    /**
     * Clean up temporary records from backend
     */
    async cleanupTemporaryRecords() {
      const currentData = store.getState().stuffs.data || []
      const updatedData = currentData.filter(
        (staff) => !staff.pk || !staff.pk.startsWith("temp_")
      )
      this.setData(updatedData)
    },
    async updateStuff(payload) {
      appLogger.info("updateStuff", `[REDUX][${STORES.STUFFS}]`)
      this.setAction(globalConst.action.UPDATE_STUFF)
      try {
        const body = {
          ...payload,
          role: canonicalAdminRole(payload.role || payload.group || payload.sk),
          name: payload.name || payload.fullname
        }
        await adminsApiPut(staffPath(payload.pk), body)
        this.setMessage("msg_stuffs_updated_success")
        this.setAction(globalConst.action.NONE)
        
        // Update the specific record in the current data
        const currentData = store.getState().stuffs.data || []
        const updatedData = currentData.map(staff => 
          staff.pk === payload.pk ? { ...staff, ...payload } : staff
        )
        this.setData(updatedData)
      } catch (error) {
        this.setAction(globalConst.action.NONE)
        throw new Error(error)
      }
    },

    /**
     *
     * @param {*} id
     */
    async disableStuff(id) {
      appLogger.info("disableStuff", `[REDUX][${STORES.STUFFS}]`)
      this.setAction(globalConst.action.DISABLE_STUFF)
      try {
        await adminsApiPut(staffPath(id), { status: "DISABLED" })
        this.setMessage("msg_stuff_disabled")
        this.setAction(globalConst.action.NONE)
        
        // Update the specific record in the current data
        const currentData = store.getState().stuffs.data || []
        const updatedData = currentData.map(staff => 
          staff.pk === id ? { ...staff, status: "DISABLED" } : staff
        )
        this.setData(updatedData)
      } catch (error) {
        const _error = error.message || error.response
        this.setError(_error)
        this.setAction(globalConst.action.NONE)
        throw new Error(error)
      }
    },
    /**
     *
     * @param {*} id
     */
    async enableStuff(id) {
      appLogger.info("enableStuff", `[REDUX][${STORES.STUFFS}]`)
      this.setAction(globalConst.action.ENABLE_STUFF)
      try {
        await adminsApiPut(staffPath(id), { status: "ACTIVE" })
        this.setMessage("msg_stuff_enabled")
        this.setAction(globalConst.action.NONE)
        
        // Update the specific record in the current data
        const currentData = store.getState().stuffs.data || []
        const updatedData = currentData.map(staff => 
          staff.pk === id ? { ...staff, status: "ACTIVE" } : staff
        )
        this.setData(updatedData)
      } catch (error) {
        const _error = error.message || error.response
        this.setError(_error)
        this.setAction(globalConst.action.NONE)
        throw new Error(error)
      }
    },
    /**
     * Delete user from Cognito
     * @param {string} email - User's email
     * @returns {Promise}
     */
    async deleteCognitoUser() {
      return { skipped: true }
    },
    /**
     *
     * @param {*} idOrPayload
     */
    async deleteStuff(idOrPayload) {
      appLogger.info("deleteStuff", `[REDUX][${STORES.STUFFS}]`)
      this.setAction(globalConst.action.DELETE_STUFF)
      try {
        // Handle both simple id parameter and complex payload object
        const id = typeof idOrPayload === 'string' ? idOrPayload : idOrPayload.pk
        const isTemporary = typeof idOrPayload === 'object' && idOrPayload.isTemporary
        const email = typeof idOrPayload === 'object' ? idOrPayload.email : null
        
        // First, remove from local data immediately
        const currentData = store.getState().stuffs.data || []
        const filteredData = currentData.filter(staff => staff.pk !== id)
        this.setData(filteredData)
        
        // For temporary IDs or invalid IDs, try to delete from backend as well
        if (
          isTemporary ||
          (id && (id.startsWith("temp_") || id === "new" || id === "undefined" || id === "null"))
        ) {
          this.setMessage("msg_stuff_deleted")
          this.setAction(globalConst.action.NONE)
          return { success: true, message: "Temporary record removed locally" }
        }

        if (id && !id.startsWith("temp_") && id !== "new" && id !== "undefined" && id !== "null") {
          try {
            await adminsApiPut(staffPath(id), {
              status: "DELETED",
              deletedAt: new Date().toISOString(),
              isDeleted: true
            })
            this.setMessage("msg_stuff_deleted")
            this.setAction(globalConst.action.NONE)
            return { success: true, message: "Record marked as deleted in backend" }
          } catch (backendError) {
            try {
              await adminsApiPut(staffPath(id), { status: "DISABLED" })
              this.setMessage("msg_stuff_deleted")
              this.setAction(globalConst.action.NONE)
              return { success: true, message: "Record marked as disabled in backend" }
            } catch (disableError) {
              this.setMessage("msg_stuff_deleted")
              this.setAction(globalConst.action.NONE)
              return {
                success: true,
                message: "Record removed from local data (backend update failed)",
                warning: "Backend update failed, record may reappear after page refresh"
              }
            }
          }
        }
        
        // If we get here, the record was already removed from local data
        this.setMessage("msg_stuff_deleted")
        this.setAction(globalConst.action.NONE)
        return { success: true, message: "Record removed" }
        
      } catch (error) {
        console.error('Delete error:', error)
        const _error = error.message || error.response
        this.setError(_error)
        throw new Error(error)
      }
    },
    /**
     *
     * @param {*} payload
     */
    async resetPassword(payload) {
      appLogger.info("resetPassword", `[REDUX][${STORES.STUFFS}]`)
      this.setAction(globalConst.action.RESET_PASSWORD)
      try {
        const id = typeof payload === "string" ? payload : payload.pk
        const password = typeof payload === "object" ? payload.password : undefined
        if (!password) throw new Error("password required")
        await adminsApiPost(staffPath(id, "/reset-password"), { password })
        this.setMessage("msg_password_reset_success")
        this.setAction(globalConst.action.NONE)
        await this.fetchStuffs()
      } catch (error) {
        const _error = error.message || error.response
        this.setError(_error)
        this.setAction(globalConst.action.NONE)
        throw error
      }
    },
    async resetPasswordStuff(payload) {
      return this.resetPassword(payload)
    },
    /**
     * Get stuff by PK
     *
     * @param {*} id
     */
    async getStuff(id) {
      appLogger.info("getStuff", `[REDUX][${STORES.STUFFS}]`)
      this.setAction(globalConst.action.GET_STUFF)
      try {
        // When using local development with /commons in base URL, 
        // we should NOT add /commons to the endpoint path
        const result = await adminsApiGet(staffPath(id))
        this.setCurrent(result)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        throw new Error(error)
      }
    },
    /**
     *
     */
    onAcionReset() {
      this.setAction(globalConst.action.NONE)
    },
    /**
     *
     * @param {*} param0
     */
    resetCurrentRecord(payload = {}) {
      this.setCurrent(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onItemPerPageChange(payload) {
      this.setitemPerPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onFiltersChange(payload) {
      this.setFilters(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onKeywordChange(payload) {
      this.setKeyword(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onCurrentPageChange(payload) {
      this.setCurrentPage(payload)
    },
    /**
     * Manually refresh staff list and retry operation
     * @param {Function} operation - The operation to retry after refresh
     */
    async refreshAndRetry(operation) {
      try {
        await this.fetchStuffs()
        // Wait a moment for the data to update
        setTimeout(() => {
          operation()
        }, 1000)
      } catch (error) {
        throw error
      }
    },
    /**
     * Manually save staff to database (for cases where initial save failed)
     * @param {Object} staffData - Staff data to save
     */
    async manuallySaveToDatabase(staffData) {
      return this.saveNewStuff(staffData)
    },
    async syncCognitoUsersToDatabase() {
      await this.fetchStuffs()
      return { savedCount: 0, errorCount: 0, skipped: true }
    },
    /**
     * Debug function to check current staff data and filters
     */
    debugStaffData() {
      const currentState = store.getState().stuffs
      // Debug logging removed for production
    }
  })
}

function getRoleValue(options, value) {
  if (!Array.isArray(options)) return null;
  for (const option of options) {
    if (option && typeof option === "object" && typeof option.value === "string") {
      if (option.value === (typeof value === "string" ? value : "")) {
        return option;
      }
    }
  }
  return null;
}
